import type { CustomDesignsReminderHideReason, CustomDesignsReminderState } from './CustomDesignsReminder.types';

/** One payload for the dashboard and the website designer, so every completion lands on the same event. */
export const customDesignsReminderCompletedEvent = ({ state, reason }: Readonly<{ state: CustomDesignsReminderState; reason: CustomDesignsReminderHideReason }>) => ({
  action: 'ButtonInteracted',
  category: 'website',
  pagePrefix: 'admin',
  label: 'Complete custom designs reminder',
  extraInfo: { state, reason },
});
